export default __webpack_public_path__ + "static/36-57b35adb3393a49843c0b60dd881db21.png";